import {
  ContentSummary as ContentSummaryBase,
  Wrapper as FilterWrapper,
} from '@aibees/elephant/feature/search-filters/components/filter/styles';
import { AccordionSummary, Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(FilterWrapper)`
  border: 1px solid ${(p) => p.theme.palette.primary[50]};
  border-radius: ${(p) => p.theme.spacing(1)};

  &.open {
    border-color: ${(p) => p.theme.palette.primary[500]};
    border-radius: ${(p) => p.theme.spacing(1)};
  }

  &:before {
    opacity: 0;
  }
`;

export const Summary = styled(AccordionSummary)`
  align-items: center;
  border-radius: ${(p) => p.theme.spacing(1)};

  &.Mui-expanded {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }

  & > .MuiAccordionSummary-expandIconWrapper {
    align-self: flex-start;
    margin: ${(p) => p.theme.spacing(1.5)} 0;
  }

  &.inMoreFilter {
    background-color: white;
    border-radius: ${(p) => p.theme.spacing(1)};
  }

  &.mini {
    padding: ${(p) => p.theme.spacing(1)} 0;

    .MuiAccordionSummary-content {
      justify-content: center;
    }
  }

  &:hover {
    background-color: ${(p) => p.theme.palette.primary[50]};
    .isPinned {
      display: inline-block;
    }
    svg {
      & > div {
        color: ${(p) => p.theme.palette.primary[500]};
      }
    }
    .PinIcon {
      color: ${(p) => p.theme.palette.primary[200]};
    }
  }
`;

export const ContentSummary = styled(ContentSummaryBase)`
  gap: ${(p) => p.theme.spacing(1)};
`;

export const HeaderWrapper = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const TitleWrapper = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${(p) => p.theme.spacing(1)};
`;
